import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/baumkataster/preview.png'


const _withScopeId = n => (_pushScopeId("data-v-ef249172"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landingpage-background w-screen h-screen" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex flex-col justify-between",
    style: {"height":"1020px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-3xl md:text-3xl" }, "Bericht zur Regelkontrolle")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        width: "600"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h-full max-h-full" }, "To be clarified")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang,
    class: "pdf-content"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}